import _objectSpread from "/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread";
import produce from 'immer';
import * as io from 'io-ts';
export function immutableCopyFunction(t, a, b) {
  var c = produce(a, function () {
    return _objectSpread({}, a, b);
  });
  return io.exact(t).decode(c);
}